import { useAppDispatch, useAppSelector } from "@/store/hooks"
import { setState } from "@/store/globalSlice"
import { socket } from "@/utils/utils"
import ModalButton from "@/Components/ModalButton"

/**
 * Full-screen overlay shown while the game is manually paused (single-human games only).
 * Resuming clears the local flag and tells the server to resume the turn timer.
 */
const PauseOverlay: React.FC = () => {
  const dispatch = useAppDispatch()
  const isGamePaused = useAppSelector((state) => state.global.isGamePaused)
  const gameId = useAppSelector((state) => state.global.myGame?.id)

  if (!isGamePaused) return null

  const handleResume = () => {
    dispatch(setState({ isGamePaused: false }))
    socket.emit("game.setTurnTimerPaused", gameId || "", false)
  }

  return (
    <div className="fixed inset-0 z-[1000] flex flex-col items-center justify-center gap-10 bg-black/80 backdrop-blur-md">
      <div className="flex flex-col items-center gap-4">
        <i className="fa-solid fa-pause text-white/90 text-6xl"></i>
        <h1 className="text-white font-poppins font-bold text-5xl tracking-wide">Game Paused</h1>
        <p className="text-white/60 font-poppins text-lg">The turn timer is frozen.</p>
      </div>
      <ModalButton color="green" onClick={handleResume}>
        <div className="flex items-center gap-3">
          <i className="fa-solid fa-play fa-lg"></i>
          <span>Resume</span>
        </div>
      </ModalButton>
    </div>
  )
}

export default PauseOverlay
